import React from "react";

import { useDateRender } from "../../../hooks";
import { LabeledText } from "./LabeledText";

export interface LabeledDateTimeProps {
    textFontSize?: number;
    direction?: "vertical" | "horizontal";
    labelFontSize?: number;
    label: string;
    value?: Date;
    testId?: string;
}

export const LabeledDate = ({
    value,
    label,
    direction,
    textFontSize,
    labelFontSize,
    testId
}: LabeledDateTimeProps): JSX.Element => {
    const { renderDate } = useDateRender();

    return (
        <LabeledText
            label={label}
            value={value ? renderDate(value) : "-"}
            direction={direction}
            textFontSize={textFontSize}
            labelFontSize={labelFontSize}
            testId={testId}
        />
    );
};
